import { gql } from '@apollo/client';

import { ProfessorActivity, ActivityInput } from '../../types';
import { professorActivityFragment } from '../fragments';

export interface CreateActivityMutationVariables {
  courseId: string;
  input: ActivityInput;
}

export interface CreateActivityMutationResult {
  activity: ProfessorActivity;
}

export const createActivityMutation = gql`
  mutation CreateActivity($courseId: String!, $input: CreateActivityInput!) {
    activity(courseId: $courseId, input: $input) @rest(type: "Activity", path: "courses/{args.courseId}/activities", method: "POST") {
      ...ProfessorActivity
    }
  }
  ${professorActivityFragment}
`;
